import { addTranslations } from "@app/i18n";
import { useTranslation } from "react-i18next";

const RESOURCE_KEY = "home-page";

const keys = addTranslations(RESOURCE_KEY, {
    configuration_hi: {
        en: "Hi, {{name}}",
        fr: "Bonjour, {{name}}",
    },
    configuration_how_can_help: {
        en: "How can I help you today?",
        fr: "Comment puis-je vous aider aujourd'hui ?",
    },
});

export const useAgentsTranslations = () => {
    const { t } = useTranslation(RESOURCE_KEY);
    return { t, keys };
};
